import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 flex justify-center bg-black/60" }
const _hoisted_2 = { class: "p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_3 = { class: "flex flex-col w-full text-black" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-50 bg-black/20"
}
const _hoisted_5 = { class: "flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_6 = { class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis pb-1" }
const _hoisted_7 = {
  key: 0,
  class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis pb-1 uppercase"
}
const _hoisted_8 = {
  key: 1,
  class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis pb-1 uppercase"
}
const _hoisted_9 = { class: "container p-4 text-left space-y-3" }
const _hoisted_10 = {
  id: "chatScroll",
  class: "flex-1 max-h-[65vh] overflow-y-auto space-y-3"
}
const _hoisted_11 = {
  key: 0,
  class: "flex"
}
const _hoisted_12 = { class: "bg-gray-100 p-3 rounded-lg shadow w-8/12 flex flex-col" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "text-xs" }
const _hoisted_15 = {
  key: 1,
  class: "flex justify-end"
}
const _hoisted_16 = { class: "bg-green-500 text-white p-3 rounded-lg shadow w-8/12 flex-col" }
const _hoisted_17 = { class: "text-sm" }
const _hoisted_18 = { class: "text-xs" }
const _hoisted_19 = { class: "flex gap-2 flex-shrink-0" }
const _hoisted_20 = { class: "px-3 pb-3 flex flex-col md:flex-row gap-2 justify-end w-full bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Field = _resolveComponent("Field")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "m-5 w-full md:w-8/12 lg:w-5/12",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.closeDialog(true)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BlockUI, { visible: _ctx.blocked }, {
              default: _withCtx(() => [
                (_ctx.blocked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_ProgressSpinner, {
                        style: {"width":"50px","height":"50px"},
                        strokeWidth: "5",
                        fill: "transparent",
                        animationDuration: ".5s"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'fa-envelope'],
                      class: "w-6 h-6 text-white"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('menu.mensajes')), 1),
                  (_ctx.mensaje.acreditadoDe.id === _ctx.acreditado.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.mensaje.acreditadoPara.nombre + ' ' + _ctx.mensaje.acreditadoPara.apellido), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.mensaje.acreditadoDe.nombre + ' ' + _ctx.mensaje.acreditadoDe.apellido), 1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mensajes, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id
                      }, [
                        (item.acreditadoDe.id === _ctx.acreditado.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, _toDisplayString(item.acreditadoDe.nombre + ' ' + item.acreditadoDe.apellido), 1),
                                _createTextVNode(" " + _toDisplayString(item.mensaje) + " ", 1),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatDate(item.fechaAlta, 'dd/mm/yyyy hh:mm:ss')), 1)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, _toDisplayString(item.acreditadoDe.nombre + ' ' + item.acreditadoDe.apellido), 1),
                                _createTextVNode(" " + _toDisplayString(item.mensaje) + " ", 1),
                                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatDate(item.fechaAlta, 'dd/mm/yyyy hh:mm:ss')), 1)
                              ])
                            ]))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      name: "stand",
                      modelValue: _ctx.respuesta,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.respuesta) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_TextArea, _mergeProps({ rows: "3" }, field, {
                          type: "text",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                          placeholder: _ctx.$t('label.ingrese.mensaje')
                        }), null, 16, ["placeholder", "class"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.responder())),
                    class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-reply'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.responder')), 1)
                  ]),
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeDialog(true))),
                    class: "cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-xmark'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cerrar')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}